import generateColorGradation from '../_util/generateColorGradation';
export default generateColorGradation;
